<script setup>
// core
import { ref, getCurrentInstance, computed, onMounted } from "vue";

// components
import HeaderMain from "@/components/Recurring/HeaderMain.vue";
import ChangeUserData from "@/components/User/ChangeUserData.vue";
import ChangeUserPassword from "@/components/User/ChangeUserPassword.vue";

// store
import {useStore} from "vuex";
const store = useStore();

const dataLoading = computed(() => store.getters['user/getInfoLoading']);
const passwordLoading = computed(() => store.getters['user/getPasswordLoading']);
const currentUserData = computed(() => store.getters['user/getCurrentUserData'])
const { proxy } = getCurrentInstance();
const passwordKey = ref(0)

const updateUserInfo = async (_payload) => {
    await store.dispatch('user/updateUserInfo', 
    {
        payload: 
            {
                full_name: _payload.name,
                email: _payload.email,
                company_name: _payload.company_name
            },
        moshaToast: proxy.$moshaToast 
    })
}

const updateUserPassword = async (payload) => {
    await store.dispatch('user/updateUserPassword', { payload, moshaToast: proxy.$moshaToast })
    passwordKey.value++
};

onMounted(async () => {
    await store.dispatch('user/getCurrentUserInfo')
})
</script>

<template>
    <section class="page">
        <HeaderMain class="page__title">{{ $t('profile.title') }}</HeaderMain>
        <div class="user-info">
            <div class="user-info__block">
                <ChangeUserData 
                    :loading="dataLoading" 
                    :current-data="currentUserData" 
                    @submit="updateUserInfo" 
                />
            </div>
            <div class="user-info__block">
                <ChangeUserPassword :key="passwordKey" :loading="passwordLoading" @submit="updateUserPassword" />
            </div>
        </div>
    </section>
</template>

<style lang="scss" scoped>
.page {
    padding: 20px;

    &__title {
        margin-bottom: 30px;
    }
}

.user-info {
    display: flex;
    gap: 34px;

    &__block {
        border-radius: 11px;
        background: var(--block-color);
        box-shadow: 0px 10px 13px 0px rgba(122, 112, 223, 0.22);
        padding: 38px 30px 32px 30px;
        flex: 1;
    }

    @media screen and (max-width: 950px) {
        flex-direction: column;
    }
}
</style>